export const musicCollection_8219 = {
    "@type": "Context",
    "id": 8219,
    "title": "House",
    "description": "14",
    "lastChanged": null,
    "changeableParameter": [
        {
            "@type": "ChangeableSelectionParameter",
            "name": "Mood",
            "metadataDisplayType": "TEXT_CHECKBOX_SELECTION",
            "metadataDisplayName": "Mood",
            "value": [
                {
                    "value": "Bright",
                    "selected": true
                },
                {
                    "value": "Dynamic",
                    "selected": false
                }
            ]
        },
        {
            "@type": "ChangeableSelectionParameter",
            "name": "Substyle",
            "metadataDisplayType": "TEXT_CHECKBOX_SELECTION",
            "metadataDisplayName": "Substyle",
            "value": [
                {
                    "value": "Deep House",
                    "selected": true
                },
                {
                    "value": "House",
                    "selected": true
                },
                {
                    "value": "Minimal House",
                    "selected": true
                },
                {
                    "value": "Progressive House",
                    "selected": true
                },
                {
                    "value": "Tech House",
                    "selected": true
                }
            ]
        },
        {
            "@type": "ChangeableIntervalParameter",
            "name": "year",
            "metadataDisplayType": "NUMERIC_SLIDER_RANGE_SELECTION",
            "metadataDisplayName": "year",
            "minimum": 1992,
            "maximum": 2019,
            "step": 1,
            "lowerSelection": 1992,
            "upperSelection": 2019,
            "metadataDisplayMinimum": "-",
            "metadataDisplayMaximum": "+"
        },
        {
            "@type": "ChangeableIntervalParameter",
            "name": "Region Popularity",
            "metadataDisplayType": "NUMERIC_SLIDER_RANGE_SELECTION",
            "metadataDisplayName": "Region Popularity",
            "minimum": 4,
            "maximum": 6,
            "step": 1,
            "lowerSelection": 5,
            "upperSelection": 6,
            "metadataDisplayMinimum": "4",
            "metadataDisplayMaximum": "6"
        }
    ],
    "defaultChangeableParameter": [
        {
            "@type": "ChangeableSelectionParameter",
            "name": "Mood",
            "metadataDisplayType": "TEXT_CHECKBOX_SELECTION",
            "metadataDisplayName": "Mood",
            "value": [
                {
                    "value": "Bright",
                    "selected": true
                },
                {
                    "value": "Dynamic",
                    "selected": false
                }
            ]
        },
        {
            "@type": "ChangeableSelectionParameter",
            "name": "Substyle",
            "metadataDisplayType": "TEXT_CHECKBOX_SELECTION",
            "metadataDisplayName": "Substyle",
            "value": [
                {
                    "value": "Deep House",
                    "selected": true
                },
                {
                    "value": "House",
                    "selected": true
                },
                {
                    "value": "Minimal House",
                    "selected": true
                },
                {
                    "value": "Progressive House",
                    "selected": true
                },
                {
                    "value": "Tech House",
                    "selected": true
                }
            ]
        },
        {
            "@type": "ChangeableIntervalParameter",
            "name": "year",
            "metadataDisplayType": "NUMERIC_SLIDER_RANGE_SELECTION",
            "metadataDisplayName": "year",
            "minimum": 1992,
            "maximum": 2019,
            "step": 1,
            "lowerSelection": 1992,
            "upperSelection": 2019,
            "metadataDisplayMinimum": "-",
            "metadataDisplayMaximum": "+"
        },
        {
            "@type": "ChangeableIntervalParameter",
            "name": "Region Popularity",
            "metadataDisplayType": "NUMERIC_SLIDER_RANGE_SELECTION",
            "metadataDisplayName": "Region Popularity",
            "minimum": 4,
            "maximum": 6,
            "step": 1,
            "lowerSelection": 5,
            "upperSelection": 6,
            "metadataDisplayMinimum": "4",
            "metadataDisplayMaximum": "6"
        }
    ],
    "visible": true,
    "editable": false,
    "favourite": false,
    "selected": false,
    "mostPlayed": false,
    "defaultSelected": false
};